import { VideoOption } from '@openx/types/targeting/video';

export const placementAndFormat: (typeof VideoOption.PLACEMENT | typeof VideoOption.PRESENTATION_FORMAT)[] = [
  VideoOption.PLACEMENT,
  VideoOption.PRESENTATION_FORMAT,
];
